import Button from "@material-ui/core/Button"
import React, { Fragment } from "react"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
import DialogActions from "@material-ui/core/DialogActions"
import Grid from "@material-ui/core/Grid"
import Annex from "./Annex"
import HeadImg from "./HeadImg"
import FieldInput from "./FieldInput"
import Checked from "./Checked"
import { useDialog } from "./hooks/dialog"
import { useDialogStyles } from "./styles"
import { Material } from "Types/material"

interface ComponentProps {
    modifyData: Material | null,
    open: boolean,
    handleGrab?: (fieldName: string) => void,
    update: boolean,
    isBom?: boolean,
    handleClose: () => void,
    handleConfirm: (editData: Material) => void,
}

const BomDialog = (props: ComponentProps) => {
    const classes = useDialogStyles()
    const { modifyData, open, handleClose, handleConfirm, update, isBom = false } = props

    const {
        handleGrab,
        title, projectName, link, disabled, headImg,
        authorName, originalLink, personInCharge, comment, summary,
        onConfirm, handleSubmit, annexes, isWeibo, isSpecies, isHealth,
        copyWriting, inputDisabled, content, isUpload,
        isPass, isTiming, departmentName, projectCode, isUser, isWechat,
        isDraft, isMine, isEditorOfEditPartment, isMyPrincipal,
    } = useDialog(modifyData, handleConfirm, update, isBom)
    const dialogTitle = "物料编辑"
    const dialogContent = (isSpecies || isHealth) ? "预约说明" : "内容"
    return (
        <Dialog open={open}>
            <DialogTitle>{dialogTitle}</DialogTitle>
            <DialogContent>
                <FieldInput
                    label={dialogContent}
                    fieldName="content"
                    disabled={(isPass && !isDraft) || !update}
                    initialText={content}
                    onConfirm={onConfirm}
                />
                <FieldInput
                    label="项目编码"
                    fieldName="project_code"
                    required={departmentName === "business"}
                    disabled={inputDisabled}
                    initialText={projectCode}
                    onConfirm={onConfirm}
                />
                <FieldInput
                    label="项目名称"
                    fieldName="project_name"
                    required={departmentName === "business"}
                    disabled={inputDisabled}
                    initialText={projectName}
                    onConfirm={onConfirm}
                />
                <FieldInput
                    label="标题"
                    required={!isWeibo}
                    fieldName="title"
                    disabled={inputDisabled}
                    initialText={title}
                    onConfirm={onConfirm}
                />
                <FieldInput
                    label="链接"
                    required={!isWeibo}
                    fieldName="link"
                    disabled={inputDisabled}
                    initialText={link}
                    onConfirm={onConfirm}
                    endBtns={[{
                        name: '抓取',
                        style: {
                            color: typeof (link) === 'string' && link.indexOf('weixin') < 0 ?
                                '#333' :
                                "#4caf50",
                            cursor: "pointer", width: 50, textAlign: 'center'
                        },
                        clickFunc: () => handleGrab && handleGrab("link")
                    }]}
                />
                <HeadImg
                    fieldName="head_img"
                    required={!isWeibo}
                    initialHeadImg={headImg}
                    onConfirm={onConfirm}
                    disabled={inputDisabled}
                />
                <FieldInput
                    label="摘要"
                    required={!isWeibo}
                    disabled={inputDisabled}
                    fieldName="summary"
                    initialText={summary}
                    onConfirm={onConfirm}
                />
                {
                    isWeibo && (
                        <FieldInput
                            label="文案"
                            fieldName="copy_writing"
                            disabled={inputDisabled}
                            initialText={copyWriting}
                            required={isWeibo}
                            onConfirm={onConfirm}
                            multiline={true}
                        />
                    )
                }
                <FieldInput
                    label="作者"
                    required={!isWeibo}
                    disabled={inputDisabled}
                    fieldName="author_name"
                    initialText={authorName}
                    onConfirm={onConfirm}
                />
                <Annex
                    fieldName="annexes"
                    initialAnnex={annexes}
                    onConfirm={onConfirm}
                    disabled={inputDisabled}
                />
                {
                    !isWeibo && (
                        <FieldInput
                            label="阅读原文的链接"
                            disabled={inputDisabled}
                            fieldName="original_link"
                            initialText={originalLink}
                            required={false}
                            onConfirm={onConfirm}
                        />
                    )
                }
                <FieldInput
                    label="营销负责人"
                    fieldName="person_in_charge"
                    disabled={inputDisabled}
                    initialText={personInCharge}
                    required={false}
                    onConfirm={onConfirm}
                />
                <FieldInput
                    label="备注"
                    fieldName="comment"
                    disabled={inputDisabled}
                    initialText={comment}
                    required={false}
                    onConfirm={onConfirm}
                />
            </DialogContent>
            <DialogActions>
                <Grid container justify="space-between" alignItems="center">
                    <Grid item>
                        {
                            isWeibo && !isBom && (
                                <Checked
                                    fieldName="is_timing"
                                    label="是否定时"
                                    onConfirm={onConfirm}
                                    initialChecked={isTiming}
                                    disabled={!update || isPass}
                                />
                            )
                        }
                    </Grid>
                    <Grid item>
                        <Button className={classes.cancelButton} onClick={handleClose}>
                            取消
                        </Button>
                        {
                            (isMyPrincipal && isWechat)
                            || (isWeibo && isMine)
                            || (isEditorOfEditPartment && !isUpload)
                            || (((isUser && !isUpload) || isMine) && (isSpecies || isHealth))
                            // 当前用户为营销部点位运营时，可以处理所有营销部物料
                            || (isUser && departmentName === 'marketing') ? (
                                <Fragment>
                                    <Button
                                        className={classes.unfinishedButton}
                                        onClick={() => handleSubmit("unfinished")}
                                        disabled={inputDisabled}
                                    >
                                        保存（未定稿）
                                    </Button>
                                    <Button
                                        className={classes.finishedButton}
                                        onClick={() => handleSubmit("finished")}
                                        disabled={inputDisabled || disabled}
                                    >
                                        保存（已定稿）
                                    </Button>
                                </Fragment>
                            ) : (
                                <Button
                                    className={classes.unfinishedButton}
                                    onClick={() => handleSubmit()}
                                    disabled={isPass || disabled}
                                >
                                    保存
                                </Button>
                            )
                        }
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default BomDialog
